import { useMemo } from 'react'
import { DateTime } from 'luxon'
import { CANVASS_MAX_ENTITLEMENTS, isNotDefined, type Entitlement } from '@terros/common'
import { useFeature } from '../feature'
import { useEntitlements } from './list'

export function useHasEntitlement(entitlement: Entitlement, fallback?: boolean): boolean {
  const { data } = useEntitlements()

  if (!data) return fallback ?? false
  return data.entitlements.includes(entitlement)
}

const CANVASS_MAX_TRIAL_FEATURE_ID = 'Feature:CanvassProTrial'
export function useCanvassMaxTrial(): { expirationDate: DateTime } | undefined {
  const { isEnabled } = useFeature({ featureId: CANVASS_MAX_TRIAL_FEATURE_ID })
  const { data } = useEntitlements()

  return useMemo(() => {
    if (!isEnabled) return
    if (isNotDefined(data)) return
    const purchasedSet = new Set(data.purchased)
    const hasTrial = !CANVASS_MAX_ENTITLEMENTS.every((entitlement) => purchasedSet.has(entitlement))
    if (!hasTrial) return
    const trialDate = data.trials.at(0)?.expiresAt
    if (isNotDefined(trialDate)) return
    const expirationDate = DateTime.fromMillis(trialDate)
    return { expirationDate }
  }, [isEnabled, data])
}
